import { usersRepo } from '@/constants/providers';
import { UserKey } from '@/modules/Users/queries/types';
import { useQuery } from '@tanstack/react-query';

type UseLinkUserAccountProps = {
  disabled: boolean;
};

export function useLinkUserAccount({ disabled }: UseLinkUserAccountProps) {
  return useQuery({
    queryKey: [UserKey.CURRENT_USER_LINK_ACCOUNT],
    queryFn: () => usersRepo.linkCurrentUser(),
    enabled: !disabled,
  });
}
